export default "__VITE_ASSET__D_I2f4XD__"